<div class="error-state" [class.error-state--small]="small" [class.error-state--transparent]="transparent">
  @if (small) {
    <ftr-icon-legacy icon="ErrorCircleLine" color="Brand" size="ExtraLarge" align="Middle" />
  } @else {
    <ftr-illustration [illustration]="illustration.Error" />
  }

  <p>
    @if (errorMessage) {
      {{ errorMessage }}
    } @else {
      {{ entityName | ftrCapitalizeFirstLetter }} failed to load. <br />Please
      <a href (click)="$event.preventDefault(); onRetry.emit()">refresh</a> the page or try again later.
    }
  </p>
</div>
